import {watch as expirationWatch} from '../actions/expiration';

export function request() {
    return {
        type: 'NOTIFICATIONS_GET_REQUEST'
    };
}

export function error(errors) {
    return {
        type: 'NOTIFICATIONS_GET_ERROR',
        errors
    };
}

export function finish(notifications) {
    return dispatch => {
        notifications.forEach(
            notification => dispatch(expirationWatch(notification))
        );

        dispatch({
            type: 'NOTIFICATIONS_GET_FINISH',
            notifications
        });
    };
}
